import { propOr } from 'ramda';
import { createSelector } from 'reselect';
import accountSelector from './accountSelector';

export default function accountRequestsPendingFeedbackSelector(state: any): [] {
  return createSelector(accountSelector, propOr('', 'requestsPendingFeedback'))(state) as [];
}
